import React, { useRef, useEffect } from 'react'
import { Text } from 'components/forms'
import Button from 'components/Button'
import Divider from 'components/Divider'
import style from './auth.module.scss'
import AuthContainer from './AuthContainer'
import { withTranslation } from 'react-i18next'


const SignIn = (props) => {
	const formApi = useRef(null)
	const { t, authProps } = props

	useEffect(() => {
		if(authProps.error && formApi.current) {
			switch(authProps.error) {
				case 'User is disabled':
					formApi.current.setError('username', t('auth_screen.error.user_disabled'))
					break
				case 'Incorrect username or password.':
					formApi.current.setError('username', t('auth_screen.error.incorrect_password'))
					break
				case 'Network error':
					formApi.current.setError('username', t('auth_screen.error.network'))
					break
				case 'Access Token has been revoked':
					formApi.current.setError('username', t('auth_screen.error.not_authorized'))
					break
				default:
					formApi.current.setError('username', t('auth_screen.error.unknown'))
					break
			}
		}
	}, [authProps.error])


	const getApi = (api) => {
		formApi.current = api
	}

	const signIn = async ({ username = '', password }) => {
		if(authProps.isPending) {
			return
		}
		authProps.submitForm({
			username: username.toLowerCase(),
			password
		})
	}

	return(
		<AuthContainer getApi={getApi} className={style.form} onSubmit={signIn}>
			{({ formState: { errors } }) => (
				<>
					<p>{t('auth_screen.message.auth')}</p>
					<Divider height={20}/>
					<Text
						errors={errors}
						errorClass={style.formInputError}
						validate={v => (v ? null : t('auth_screen.error.login_required'))}
						validateOnChange
						type='text'
						field='username'
						placeholder={t('auth_screen.form.login')}
						usePlaceholder
					/>
					<Text
						errors={errors}
						errorClass={style.formInputError}
						validate={v => (v ? null : t('auth_screen.error.password_required'))}
						validateOnChange
						type='password'
						field='password'
						placeholder={t('auth_screen.form.password')}
						usePlaceholder
					/>
					<Button
						status='active'
						text={t('auth_screen.button.login')}
						type='submit'
						{...authProps.isPending && { loading: true }}
					/>
					<div className={style.linkButton} onClick={authProps.toResetPassword}>
						{t('auth_screen.button.forgot_password')}
					</div>
				</>
			)}
		</AuthContainer>
	)
}

export default withTranslation()(SignIn)
